// So redux-devtools works nicely. See https://github.com/reduxjs/redux-devtools/issues/1028#issuecomment-1032049854
// eslint-disable-next-line
import Symbol_observable from 'symbol-observable'

import '../src/globals.js'
import '../src/temporal.js'
import '../src/embed.jsx'

// We check for the existence of this variable in our DOMContentLoaded handler
// This allows us to make sure that this file has been parsed before attempting to call functions in it
// This is needed because network connection could fail during JS download, causing DOMContentLoaded to fire, but the Timetoast JavaScript not to be available
window.Timetoast.isReady = true
